/* istanbul ignore file */
// All logic is located in helpers
import React from 'react';
import { FilterProvider } from './FilterContext';
import useFilter from './useFilter';
import { ValidationSchema } from 'validation-schema-library';

const Filters = ({
  children,
  getValidationSchema,
  showAsIcon,
}: {
  children: React.ReactNode;
  getValidationSchema?: () => Promise<ValidationSchema>;
  showAsIcon?: boolean;
}) => {
  const contextValue = useFilter({
    getValidationSchemaFunc: getValidationSchema,
  });

  return (
    <FilterProvider value={contextValue}>
      {showAsIcon !== undefined
        ? React.Children.map(children, child =>
            React.isValidElement(child) ? React.cloneElement(child as React.ReactElement<any>, { showAsIcon }) : child,
          )
        : children}
    </FilterProvider>
  );
};

export default Filters;
